import React from "react";
import { Box, CircularProgress } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./Loader.styles";

const Loader = ({ color, minHeight }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      className={`${minHeight ? classes.minHeight : classes.progress}`}
    >
      <CircularProgress color={color} />
    </Box>
  );
};

Loader.defaultProps = {
  color: "primary",
  minHeight: true,
};

Loader.propTypes = {
  color: PropTypes.string,
  minHeight: PropTypes.bool,
};

export { Loader };
